export default "__VITE_ASSET__924801e2__"